import {GetSafeValue} from '../utils/get-safe-value';
import {StringFieldUtil} from '../utils/string-field-util';

export class AppLink {

  private _playStore: string;
  private _appStore: string;


  constructor() {
    this.playStore = '';
    this.appStore = '';
  }

  clone(data: AppLink){
    this.playStore = data.playStore;
    this.appStore = data.appStore;
  }

  fromJson(data: AppLink){
    this.playStore = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.playStore], "");
    this.appStore = GetSafeValue.getSafeValueAsString(data[StringFieldUtil.appStore], "");
  }

  get playStore(): string {
    return this._playStore;
  }

  set playStore(value: string) {
    this._playStore = value;
  }

  get appStore(): string {
    return this._appStore;
  }

  set appStore(value: string) {
    this._appStore = value;
  }

  toMap(){
     return{
       'playStore': this.playStore,
       'appStore': this.appStore,

     }
  }
}
